import React from 'react';
import { Button, Dropdown, Menu } from 'antd';
import styles from './index.module.scss';

const typesMap = {
  acceptance: 'acceptance',
  calendar: 'calendar',
};

const DropdownActions = ({ placement, loading = false, actions, type }) => {
  return (
    <Dropdown
      placement={placement}
      disabled={loading}
      overlay={<Overlay actions={actions} />}
    >
      <Btn type={type} loading={loading} />
    </Dropdown>
  );
};

DropdownActions.types = typesMap;

export default DropdownActions;

function Btn({ type, loading, ...props }) {
  switch (type) {
    case typesMap.acceptance:
      return <AcceptanceButton {...props} />;

    case typesMap.calendar:
      return <CalendarButton {...props} loading={loading} />;

    default:
      return null;
  }
}

function CalendarButton({ loading, ...props }) {
  return (
    <Button
      {...props}
      icon={loading ? 'loading' : 'interaction'}
      className={styles.calendarBtn}
    />
  );
}

function AcceptanceButton(props) {
  return <Button {...props} icon="edit" className={styles.acceptanceBtn} />;
}

function Overlay({ actions, onClick, ...props }) {
  const handleClick = (e) => {
    e.domEvent.stopPropagation();
    onClick(e);
  };

  return (
    <Menu {...props} onClick={handleClick}>
      {actions.map(({ name, component }) => (
        <Menu.Item key={name}>{component}</Menu.Item>
      ))}
    </Menu>
  );
}
